import { FolderTree, Settings2 } from "lucide-react";
import { Tabs } from "@shared/ui/tabs"; // Your URL-based tabs component
import { ComplaintCategoriesTab } from "./complaintCategoriesTab";
import { ComplaintConfigurationTab } from "./complaintConfigurationTab";

export function ComplaintsSettings() {
  // Configure tabs for URL-based navigation
  const tabComponents = {
    categories: {
      label: "Categories",
      shortLabel: "Categories",
      icon: <FolderTree size={16} />,
      component: <ComplaintCategoriesTab />,
      className: "flex-1" // Maintain grid-like appearance
    },
    configuration: {
      label: "Complaint Configuration",
      shortLabel: "Config",
      icon: <Settings2 size={16} />,
      component: <ComplaintConfigurationTab />,
      className: "flex-1"
    }
  };

  const urlMapping = {
    categories: "categories",
    configuration: "config"
  };

  return (
    <div className="space-y-6">
      <Tabs
        defaultValue="categories"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        idPrefix="complaints-sub-tab"
        className="w-full"
        level={1}
      />
    </div>
  );
}